import script from "./contactus.vue?vue&type=script&setup=true&lang=js"
export * from "./contactus.vue?vue&type=script&setup=true&lang=js"

import "./contactus.vue?vue&type=style&index=0&id=046f474d&lang=scss&scoped=true"

import exportComponent from "E:\\xm\\siggraph\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-046f474d"]])

export default __exports__